import type { ContentfulEventFragment } from '@/graphql/contentful/api';

import { renderContentfulPlaceholderEventSection } from './cms';

export const PlaceholderEvent = (props: ContentfulEventFragment) => {
  return <>{renderContentfulPlaceholderEventSection(props)}</>;
};
